/**
 * 使用范围
 * 场次打印
 * */
import { createStore } from '@souche-f2e/muji';
import API from '@/services';
// desc 场次打印信息详情-数据
const detailData = {
    sceneId: '',
    sceneName: '',
    sceneType: '',
    endTime: '',
    auctionStartTime: '',
    carAuctionDuration: '',
    sceneAddress: '',
    bidStartDate: '',
    courseMoney: '',
    status: '',
    frozenType: ' ',
    deadlineOfStartBidding: '',
    showAuctionListIframe: false,
};
export default createStore({
    state: Object.assign({}, detailData),
    effects: {
        queryDetail(params, { state, rootState }) {
            this.SET_STATE({
                roundId: rootState.router.query.id,
            });
            API.auction.getScenePrinting({
                roundId: rootState.router.query.id,
            })
                .then((res) => {
                const auctionMode = res.auctionMode;
                let sceneTypes;
                let auctionStartTimeWord;
                switch (auctionMode) {
                    case 1:
                        sceneTypes = '现场拍';
                        auctionStartTimeWord = '竞拍开始时间';
                        break;
                    case 2:
                        sceneTypes = '暗拍场次';
                        auctionStartTimeWord = '竞拍开始时间';
                        break;
                    case 1001:
                        sceneTypes = '车道拍';
                        auctionStartTimeWord = '竞拍开始时间';
                        break;
                    case 1011:
                        sceneTypes = '超级拍（现场拍)';
                        auctionStartTimeWord = '投标开始时间';
                        break;
                    case 1021:
                        sceneTypes = '超级拍（车道拍)';
                        auctionStartTimeWord = '投标开始时间';
                        break;
                    default:
                        sceneTypes = '--';
                        auctionStartTimeWord = '竞拍开始时间';
                }
                this.SET_STATE({
                    auctionStartTime: auctionStartTimeWord,
                    sceneId: res.roundCode,
                    sceneName: res.roundName,
                    status: res.status,
                    sceneType: sceneTypes,
                    sceneAddress: res.roundAddress,
                    bidStartDate: res.preStartDate && res.preStartTime ? `${res.preStartDate} ${res.preStartTime}` : '',
                    courseMoney: res.roundDepositY ? Number(res.roundDepositY).toFixed(0) : '',
                    carAuctionDuration: res.carAuctionDuration,
                    endTime: res.endTime,
                    deadlineOfStartBidding: res.deadlineOfStartBidding,
                    frozenType: res.frozenType === 2 ? '单车保证金' : '场次保证金',
                    showAuctionListIframe: true,
                });
            });
        },
    },
    reducers: {
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                if (typeof payload[key] !== 'undefined') {
                    state[key] = payload[key];
                }
            });
        },
        RESET_STATE() {
            return Object.assign({}, detailData);
        },
    },
});
